import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["className", "title", "titleId", "children", "callout", "highlight", "withControl", "fixedHeight", "withOverflow"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CardControl } from '..';
var CardHeader = function CardHeader(_ref) {
  var className = _ref.className,
    title = _ref.title,
    titleId = _ref.titleId,
    children = _ref.children,
    callout = _ref.callout,
    highlight = _ref.highlight,
    withControl = _ref.withControl,
    fixedHeight = _ref.fixedHeight,
    withOverflow = _ref.withOverflow,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var stylingClass = classnames(className, 'wds-c-card__header', {
    'wds-c-card__header--highlight': highlight,
    'wds-c-card__header--with-control': withControl,
    'wds-c-card__header--with-overflow': withOverflow,
    'wds-c-card__header--link': callout,
    'wds-js-fix-height__child': fixedHeight
  });
  var titleStylingClass = classnames('wds-c-card__title', {
    'wds-js-fix-height__child wds-js-truncate-text-max-height': fixedHeight
  });
  var control = null;
  React.Children.forEach(children, function (child) {
    if (child && child.type && child.type.displayName === CardControl.displayName) {
      control = child;
    }
  });
  var otherChildren = React.Children.map(children, function (child) {
    if (!child || child === control) {
      return null;
    }
    // append the wds-js-fix-height__child class to fixed card header contents
    return fixedHeight ? /*#__PURE__*/React.cloneElement(child, {
      className: classnames(child.props.className, 'wds-js-fix-height__child')
    }) : child;
  });
  return /*#__PURE__*/React.createElement("span", _extends({
    className: stylingClass
  }, otherProps), withControl && control ? control : null, title && /*#__PURE__*/React.createElement("h3", {
    className: titleStylingClass,
    id: titleId
  }, title), otherChildren);
};
CardHeader.propTypes = {
  /** title of the card - renders inside an <h3> tag */
  title: PropTypes.node,
  /** id of the title element */
  titleId: PropTypes.string,
  /** children */
  children: PropTypes.node,
  /** additional styling */
  className: PropTypes.string,
  /** highlight */
  highlight: PropTypes.bool,
  /** specifies if the cardheader has a control element */
  withControl: PropTypes.bool,
  /** specifies if the card header contains a overflow menu */
  withOverflow: PropTypes.bool,
  /** callout card */
  callout: PropTypes.bool,
  /** indicates the header is part of a fixed height card. set internally by the Card */
  fixedHeight: PropTypes.bool
};
CardHeader.defaultProps = {
  title: undefined,
  titleId: undefined,
  className: undefined,
  highlight: false,
  children: undefined,
  withControl: false,
  callout: false,
  fixedHeight: false,
  withOverflow: false
};
CardHeader.displayName = 'CardHeader';
export default CardHeader;